module.exports = {
  home: {
    highlights: 'HIGHLIGHTS',
    strategicVision: 'STRATEGIC VISION',
    publication: 'RESOURCE SHARING',
    lancangMenong: 'LANCANG-MEKONG NOTICES',
    wantedPerson:"WANTED PERSON",
    missingPerson:"MISSING PERSON",
    links:"LINKS",
    lmleccNews:"LMLECC NEWS",
    regoionalEvents:"REGOIONAL EVENTS",
    memberStatesCooperation:"MEMBER STATES COOPERATION",
    memberStatesInternalAffairs:"MEMBER STATES INTERNAL AFFAIRS",
    intelliegenceCenter:"Intelliegence Center",//情报融合中心
    jointOperationCenter:"Joint Operation Center",//联合行动中心
    LawEnforcementCapacityBuildingCenter:"Law Enforcement Capacity Building Center",//执法能力建设中心
    EmergencyResponseCenter:"Emergency Response Center",//应急响应中心
    time:"time",
    from:"from",
    author:"author",
    share:"share",
    home:"HOME",
    aboutUs:"ABOUT US",
    aboutus:"About us",
    wantWeDo:"WHAT WE DO",
    partners:"PARTNERS",
    resource:"RESOURCE",
    eLearning:"E-LEARNING",
    contact:"CONTACT",
    activities:"Activities",
    downResource:"Download Resouces",
    pageView:"PageView",
    registration:"Registration No.",
    Organizer:"Organizer",
    Copyright:"Copyright",
    mail:"E-mail",
    RFax:"RFax",
    tel:"T e l",
    summary:"SUMMARY",
    leadership:"LEADERSHIP",
    nameAndLogo:"NAME AND LOGO",
    organizationalStructure:"ORGANIZATIONAL STRUCTURE",
    myName:"OUR NAME",
    myLogo:"OUR LOGO",
    RelevantInformation:"Relevant Information",
    search:"search",
    name:'Name',
    age:"Age",
    ageRange:"Age Range",
    sex:"Gender",
    nationality:'Nationality',
    birthAddress:'Address of birth',
    birthDay:'Date of birth',
    description:'Description',
    trait:'Trait',
    back:'Back',
    detailPage:'Details Page',
    address:"No. 1097 Guangfu Road, Xishan District, Kunming City, Yunnan Province",
    lmccName:"Lancang-Mekong integrated Law Enforcement and Security Cooperation Center",
    SecretaryGeneral:"SECRETARY-GENERAL",
    DeputySecretaryGeneral:"DEPUTY SECRETARY-GENERAL",
    CAMBODIA:"CAMBODIA",
    MYANMAR:"MYANMAR",
    LAOS:"LAOS",
    VIETNAM:"VIETNAM",
    CHINA:"CHINA",
    placeholder:"input keywords or titles…",
    recommondedSearch:"recommonded search",
    content1:"china & laos",
    content2:"joint patrol 2024",
    content3:"laos anti drugs",
    caseNumber:"CASE NUMBER",
    governments:"GOVERNMENTS",
    internationalOrganization:"INTERNATIONAL ORGANIZATION",
    academicInstitution:"ACADEMIC INSTITUTION",
    leaveMessage:"I want to leave a message",
    leaveMessageTip:"Dear visitor,Please provide valuable feedback on our work,Your attention and support are the driving force behind our progress.",
    contactUs:"Contact Us",
    submit:"Submit",
    email:"E-mail",
    theme:"Theme",
    text:"Text",
    Secretariat:"Secretariat of  LMLECC",
    organizational:"Organizational structure",
    leader:"Leader introduction",
    noData:"No data available at the moment",
    startDate:"startDate",
    endDate:"endDate",
    centerActivity:"CENTER ACTIVITIES",
    regionalNews:"REGIONAL NEWS",
    enforcementNews:"ENFORCEMENT NEWS",
    missingPersons:"LANCANG-MEKONG NOTICES",
    resources:"RESOURCE SHARING",
    videoCenter:"VIDEO CENTER",
    thinkTankDynamics:"Think Tank Dynamics",
    crimeMap:"Lancang-Mekong Regional Law Enforcement Dynamics Map",
  },
}



// WEBPACK FOOTER //
// ./src/lang/en.js